import { ClientEvents } from 'common/events/ClientEvents';
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaBadgeCheck } from 'src/shared/design-system/FontAwesome';
import { useTracker } from 'src/shared/hooks/useTracker';
import styled from 'styled-components';
import { BorderRadius, Colors, FontSize, ScreenWidth, Spacing } from 'web-common/src/shared/styles';
import mandala from './assets/mandala.png';
import { ReviewCardProps } from './types';

const Card = styled.div`
  border-radius: ${BorderRadius.M};
  background-color: ${Colors.WHITE};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  padding: ${Spacing.SINGLE};
  min-width: 240px;

  @media (max-width: ${ScreenWidth.SMALL}) {
    min-width: 70vw;
  }
`;

const ImageBackground = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  margin-bottom: ${Spacing.HALF};
  width: 100%;
  height: 120px;
  background-image: url(${mandala});
  background-size: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

const ShefImage = styled.div<{ imageUrl }>`
  background-image: url(${({ imageUrl }) => imageUrl});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 90px;
  width: 90px;
  border-radius: 50%;
`;

const ShefLink = styled.p`
  border-top: 1px solid ${Colors.GRAY};
  text-decoration: underline;
  margin-top: ${Spacing.SINGLE};
  margin-bottom: 0;
  color: ${Colors.GRAY_DARK_10};
  padding-top: ${Spacing.SINGLE};
  font-size: ${FontSize.S};
`;

const VerifiedBadgeCheck = styled(FaBadgeCheck)`
  color: ${Colors.CHIVES_LITE_10};
`;

export const ReviewCard: React.FC<ReviewCardProps> = ({ shef, user, review }) => {
  const displayDate = new Date(review.createdAt);
  const tracker = useTracker();
  const handleClick = useCallback(() => tracker.track(ClientEvents.RECENTLY_REVIEWED_CLICK, { shefId: shef.id }), []);

  return (
    <Card>
      <div>
        <ImageBackground>
          <ShefImage imageUrl={shef.imageUrl ?? ''} />
        </ImageBackground>
        <p className='text-base leading-7'>"{review.comment}"</p>
      </div>
      <div>
        <p className='mb-0 text-xs text-neutral-500'>
          {user.firstName} {displayDate.toLocaleString().split(',')[0]} <VerifiedBadgeCheck />
        </p>
        <ShefLink>
          <Link to={`/order/shef/${shef?.id}`} onClick={handleClick}>
            View Shef {shef?.firstName}'s menu
          </Link>
        </ShefLink>
      </div>
    </Card>
  );
};
